exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-files .sub-title{position:relative;font-size:18px;color:#000;text-align:left;border-bottom:1px solid #d3d3d3;padding-bottom:10px}", ""]);

// exports
